"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createSweepRuleForSenderRequest_1 = require("owa-service/lib/factory/createSweepRuleForSenderRequest");
var createSweepRuleForSenderOperation_1 = require("owa-service/lib/operation/createSweepRuleForSenderOperation");
var Utils_1 = require("owa-service/lib/Utils");
var owa_strings_1 = require("owa-strings");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
/**
 * Helper function to create the empty rule names array which has the same length of the emailAddresses array.
 * This is a workaround for server validation and will be removed after fixing
 * VSO 8796: Improve validation for utah CreateSweepRuleForSenderAction
 */
function createRuleNames(emailAddresses) {
    return emailAddresses.map(function (email) {
        return owa_strings_1.format(owa_mail_strings_1.default.messagesFrom, email.Name);
    });
}
/**
 * Create sweep rule for sender service request
 * @param emailAddresses the email addresses to be blocked
 * @return the ApplyBulkItemActionResponse
 */
function createSweepRuleForSenderService(emailAddresses, destinationFolderId, sourceFolderId, keepNType, keepNCount) {
    var requestBody = createSweepRuleForSenderRequest_1.default({
        EmailAddresses: emailAddresses,
        ActionType: 0 /* Move */,
        RuleName: null /* deprecated required param*/,
        RuleNames: createRuleNames(emailAddresses),
        SourceFolderId: { Id: sourceFolderId },
        DestinationFolderId: { Id: destinationFolderId },
        CountType: keepNType,
        KeepNCount: keepNCount,
    });
    return createSweepRuleForSenderOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
exports.default = createSweepRuleForSenderService;
//# sourceMappingURL=createSweepRuleForSenderService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/createSweepRuleForSenderService.js
// module id = 5645
// module chunks = 62